export default class Navbar {
    static init(): void {
        this.stickyNavbar();
        this.navbarAnchorScroll();
        this.mobileMenu();
    }

    static stickyNavbar(): void {
        const navbar = document.querySelector(".js-navbar-init") as HTMLElement | null;

        if (!navbar) return;

        let logoAnimateTimeout: ReturnType<typeof setTimeout> | null = null;

        const toggleNavbarClass = (): void => {
            if (window.scrollY > 0) {
            navbar.classList.add("navbar-not-top");

            // Pokud už timeout běží, zrušíme ho
            if (logoAnimateTimeout) {
                clearTimeout(logoAnimateTimeout);
            }

            // Nastavíme nový timeout pro přidání class logo-is-animate
            logoAnimateTimeout = setTimeout(() => {
                navbar.classList.add("logo-is-animate");
            }, 10);
            } else {
            navbar.classList.remove("navbar-not-top", "logo-is-animate");

            // Pokud by ještě běžel timeout, zrušíme ho
            if (logoAnimateTimeout) {
                clearTimeout(logoAnimateTimeout);
                logoAnimateTimeout = null;
            }
            }
        };

        window.addEventListener("scroll", toggleNavbarClass);
    }

    static navbarAnchorScroll(): void {
        const menuLinks = document.querySelectorAll<HTMLAnchorElement>(".js-base-header-link");
        const header = document.querySelector<HTMLElement>(".js-navbar-init");
        const offset = 100; // Výška menu

        if (menuLinks.length > 0 && header) {
            menuLinks.forEach(link => {
                link.addEventListener("click", (event) => {
                    event.preventDefault();

                    const targetId = link.getAttribute("data-header");
                    if (!targetId) return;

                    // Pokud jsme na jiné stránce než homepage, přesměrujeme na homepage
                    if (window.location.pathname !== "/" && !link.classList.contains("base-header__link--first")) {
                        sessionStorage.setItem("scrollTarget", targetId);
                        window.location.href = "/"; // Změňte na skutečnou URL vaší homepage
                        return;
                    }

                    if (window.location.pathname !== "/" && link.classList.contains("base-header__link--first")) {
                        window.location.href = "/"; // Změňte na skutečnou URL vaší homepage
                    }

                    // Podmínka pro .base-header__link--first
                    if (link.classList.contains("base-header__link--first")) {
                        if (window.scrollY === 0) {
                            closeMobileMenu();
                            return; // Pokud jsme nahoře, nic nedělat
                        } else {
                            window.scrollTo({ top: 0, behavior: "smooth" }); // Jinak posun nahoru
                            closeMobileMenu();
                            return;

                        }
                    }

                    const targetElement = document.getElementById(targetId);
                    if (!targetElement) return;

                    closeMobileMenu();

                    // Plynulý scroll k cílové sekci s posunutím o offset
                    const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;
                    window.scrollTo({ top: targetPosition, behavior: "smooth" });
                });
            });

            // Po načtení stránky zkontrolujeme, zda máme uložený cíl scrollování
            const savedTargetId = sessionStorage.getItem("scrollTarget");
            if (savedTargetId) {
                const savedTargetElement = document.getElementById(savedTargetId);
                if (savedTargetElement) {
                    const targetPosition = savedTargetElement.getBoundingClientRect().top + window.scrollY - offset;
                    window.scrollTo({ top: targetPosition, behavior: "smooth" });
                }
                sessionStorage.removeItem("scrollTarget"); // Po scrollování odstraníme uloženou hodnotu
            }
        }

        // Pokud base-header obsahuje třídu is-open, odstraníme ji
        function closeMobileMenu() {
            if (header) {
                if (header.classList.contains("is-open")) {
                    document.body.classList.remove("body-is-lock");
                    header.classList.remove("is-open", "is-animate");

                    setTimeout(() => {
                        header.classList.remove("menu-is-open");
                    }, 500);
                }
            }
        }
    }

    static mobileMenu(): void {
        const headerClassInit = document.querySelector<HTMLElement>(".js-navbar-init");
        const toggleMobileButton = document.querySelector<HTMLElement>(".base-header__toggle");
        const body = document.body;

        if (toggleMobileButton && headerClassInit) {
            toggleMobileButton.addEventListener("click", () => {
                const isOpen = headerClassInit.classList.contains("is-open");
                headerClassInit.classList.toggle("is-open", !isOpen);
                body.classList.toggle("body-is-lock", !isOpen);
                headerClassInit.classList.toggle("menu-is-open", !isOpen);

                setTimeout(() => {
                    headerClassInit.classList.toggle("is-animate", !isOpen);
                }, 10);
            });
        }

        // Odstranění tříd při změně velikosti okna nad 991px
        window.addEventListener("resize", () => {
            if (window.innerWidth > 991 && headerClassInit?.classList.contains("is-open")) {
                headerClassInit.classList.remove("is-open", "is-animate", "menu-is-open");
                body.classList.remove("body-is-lock");
            }
        });
    }
}
